import React from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import { useForm } from "@refinedev/antd";
import { ChildForm } from "interfaces/schemaDB";
import { config } from "config";
import { EditPublications } from "./";

export const PublicationsEdit: React.FC<IResourceComponentsProps> = () => {
    const resourceLabel :string = 'Publicación';
    const resourceName :string = 'publication';
    const { id } = useForm();
    const childrenForms : ChildForm[] =[
        {
            resourceName :"sectionPub",
            title : "Secciones",
            field : "sep_id_publication"
        },
        {
            resourceName :"autorPublication",
            title : "Autores",
            field : "aup_id_publication"
        },
        {
            resourceName :"autorPublication",
            title : "Generar Json",
            field : "aup_id_publication",
            url : config.urlAPI+'/publicar/publication/' +id
        },
        {
            resourceName :"autorPublication",
            title : "Ver libro",
            field : "aup_id_publication",
            url : config.urlSitelibros+'libros/' +id
        },

    ]

    return(
        <EditPublications
            resourceLabel = {resourceLabel}
            resourceName = {resourceName}
            id = {id}
            childrenForms = {childrenForms}
        ></EditPublications>
    )

};